import React from 'react';
import ReactECharts from 'echarts-for-react';
import PropTypes from 'prop-types';
import { startCase, sumBy } from 'lodash';
import { useTheme } from '../../context/ThemeContext';
import { chartTheme, chartTooltip } from '../../helpers/chartTheme';

// Risk score category colors matching the design
const RISK_COLORS = {
  priority: '#253746',
  severity: '#253746',
  status: '#4a8f99',
  workaround: '#5ba08a',
  support_case_count: '#7eb26d',
  support_case_trend: '#d4a73a',
  community_thread_views: '#cf7e3c',
  community_replies_count: '#b94a48',
  community_useful_count: '#7b4a7a'
};

// Fallback colors for any categories not in the map
const FALLBACK_COLORS = ['#253746', '#4a8f99', '#5ba08a', '#7eb26d', '#d4a73a', '#cf7e3c', '#b94a48', '#7b4a7a'];

const PieChart = ({ data }) => {
  const totalValue = sumBy(data, 'value');
  const { isDark } = useTheme();
  const t = chartTheme(isDark);

  const options = {
    tooltip: chartTooltip(t, {
      trigger: 'item',
      formatter: '{b}: {d}%'
    }),
    color: data.map((item, index) => RISK_COLORS[item.label] || FALLBACK_COLORS[index % FALLBACK_COLORS.length]),
    graphic: [
      {
        type: 'text',
        left: 'center',
        top: 'center',
        style: {
          text: `${totalValue}%`,
          fontSize: 32,
          fontWeight: 'bold',
          fill: t.ink
        }
      }
    ],
    series: [
      {
        name: 'Risk Share',
        type: 'pie',
        radius: ['55%', '80%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 0,
          borderColor: t.bg,
          borderWidth: 2
        },
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        data: data.map((item, index) => ({
          value: item.value,
          name: startCase(
            item.label === 'priority' ? item.label.replace('priority', 'severity') : item.label.replaceAll('_', ' ')
          ),
          itemStyle: {
            color: RISK_COLORS[item.label] || FALLBACK_COLORS[index % FALLBACK_COLORS.length]
          }
        })),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };

  return <ReactECharts option={options} style={{ height: '350px', width: '100%' }} />;
};

export default PieChart;
PieChart.propTypes = {
  data: PropTypes.array
};

export { RISK_COLORS };
